var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgOneLineCircle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 25,
    viewBox: "0 0 270 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FF6363"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FF6363"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 12.5,
    r: 12.5,
    fill: "#E84444"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FF8989"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FF6363"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.5,
    cy: 12.5,
    r: 12.5,
    fill: "#E84444"
  })));
}
export default SvgOneLineCircle;